import { Inject, Injectable } from '@angular/core';
import {
  Router
} from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { environment } from 'src/environments/environment';
import { WINDOW } from '../utils/window';

@Injectable({
  providedIn: 'root',
})
export class GuardService extends KeycloakAuthGuard {
  constructor(
    protected override readonly router: Router,
    protected readonly keycloak: KeycloakService,
    @Inject(WINDOW) private window: Window
  ) {
    super(router, keycloak);
  }

  public async isAccessAllowed(): Promise<boolean> {
    if (!this.authenticated) {
      await this.keycloak.login({
        redirectUri: environment.keycloak.redirectUri + this.window.location.pathname,
      });
    }

    return Promise.resolve(this.authenticated);
  }
}
